export const DASHBOARD = "/";
export const SIMPLEPURCHASE = "/purchase/simple_purchases";
export const NEWPURCHASE = "/purchase/simple_purchases/new_purchase";
export const CONTACTLISTING = "/purchase/suppliers/contacts";
export const SUPPLIERLISTING = "/purchase/suppliers";
export const SUPPLIER = "/suppliers/supplier";
export const PURCHASECREDITNOTE = "/purchases/purchase_credit_note"
export const REPORTS = '/reports'
export const NOTFOUND = "/not_found";